document.addEventListener('DOMContentLoaded', () => {
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  if (!DESKTOP.matches) return;

  const galleries = document.querySelectorAll('media-gallery[id^="MediaGallery-"]');

  galleries.forEach((gallery) => {
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return;

    const list = thumbs.querySelector('.thumbnail-list');
    const prevBtn = thumbs.querySelector('.slider-button--prev');
    const nextBtn = thumbs.querySelector('.slider-button--next');
    const thumbItems = thumbs.querySelectorAll('.thumbnail-list__item');

    if (!list || !prevBtn || !nextBtn || !thumbItems.length) return;

    const getStep = () => {
      const item = thumbItems[0];
      if (!item) return 94;
      const itemHeight = item.getBoundingClientRect().height || 84;
      const listStyle = getComputedStyle(list);
      const gap = parseFloat(listStyle.gap || listStyle.rowGap || '10') || 10;
      return itemHeight + gap;
    };

    const getMaxScroll = () => Math.max(0, list.scrollHeight - list.clientHeight);

    const updateButtons = () => {
      const top = list.scrollTop;
      const max = getMaxScroll();

      prevBtn.disabled = top <= 2;
      nextBtn.disabled = top >= max - 2;
    };

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      list.scrollBy({
        top: -getStep(),
        behavior: 'smooth'
      });
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      list.scrollBy({
        top: getStep(),
        behavior: 'smooth'
      });
    });

    list.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    const ensureActiveThumbVisible = () => {
      const activeBtn = thumbs.querySelector('.thumbnail[aria-current="true"]');
      if (!activeBtn) return;

      const activeItem = activeBtn.closest('.thumbnail-list__item');
      if (!activeItem) return;

      const itemTop = activeItem.offsetTop;
      const itemBottom = itemTop + activeItem.offsetHeight;
      const viewTop = list.scrollTop;
      const viewBottom = viewTop + list.clientHeight;

      if (itemTop < viewTop) {
        list.scrollTo({ top: itemTop, behavior: 'smooth' });
      } else if (itemBottom > viewBottom) {
        list.scrollTo({ top: itemBottom - list.clientHeight, behavior: 'smooth' });
      }
    };

    thumbs.querySelectorAll('[data-target] button').forEach((button) => {
      button.addEventListener('click', () => {
        window.setTimeout(() => {
          ensureActiveThumbVisible();
          updateButtons();
        }, 60);
      });
    });

    window.setTimeout(() => {
      ensureActiveThumbVisible();
      updateButtons();
    }, 150);
  });
});